<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="32"
    height="32"
    viewBox="9 0 90 90"
    fill="#FFF"
    stroke="currentColor"
  >
    <path
      i:knockout="Off"
      fill="#A80030"
      d="M60.969,47.645c-1.494,0.02,0.281,0.768,2.232,1.069     c0.541-0.422,1.027-0.846,1.463-1.26C63.451,47.751,62.215,47.758,60.969,47.645"
    />
    <path
      i:knockout="Off"
      fill="#A80030"
      d="M68.986,45.646c0.893-1.229,1.541-2.573,1.77-3.963     c-0.201,0.99-0.736,1.845-1.244,2.749c-2.793,1.759-0.264-1.044-0.002-2.111C66.508,46.104,69.096,44.589,68.986,45.646"
    />
    <path
      i:knockout="Off"
      fill="#A80030"
      d="M71.949,37.942c0.182-2.691-0.529-1.839-0.768-0.814     C71.459,37.274,71.68,39.026,71.949,37.942"
    />
    <path
      i:knockout="Off"
      fill="#A80030"
      d="M55.301,1.163c0.798,0.142,1.724,0.252,1.591,0.443     C57.768,1.413,57.965,1.239,55.301,1.163"
    />
    <path i:knockout="Off" fill="#A80030" d="M56.893,1.606l-0.561,0.117l0.523-0.048L56.893,1.606" />
    <path
      i:knockout="Off"
      fill="#A80030"
      d="M81.762,38.962c0.09,2.416-0.705,3.59-1.424,5.666l-1.293,0.643     c-1.057,2.054,0.105,1.304-0.652,2.937c-1.652,1.467-5.006,4.589-6.08,4.875c-0.785-0.017,0.531-0.926,0.703-1.281     c-2.209,1.516-1.773,2.276-5.152,3.199l-0.098-0.221c-8.33,3.92-19.902-3.847-19.75-14.443c-0.088,0.672-0.253,0.504-0.437,0.774     c-0.43-5.451,2.518-10.926,7.49-13.165c4.863-2.406,10.564-1.42,14.045,1.829c-1.912-2.506-5.721-5.163-10.232-4.917     c-4.421,0.072-8.558,2.881-9.938,5.932c-2.264,1.425-2.528,5.496-3.514,6.242c-1.329,9.76,2.497,13.975,8.97,18.936     c1.016,0.686,0.286,0.791,0.422,1.313c-2.15-1.006-4.118-2.526-5.738-4.387c0.86,1.257,1.787,2.479,2.986,3.439     c-2.029-0.685-4.738-4.913-5.527-5.085c3.495,6.258,14.178,10.975,19.775,8.634c-2.59,0.096-5.879,0.053-8.787-1.022     c-1.225-0.629-2.884-1.93-2.587-2.173c7.636,2.851,15.522,2.158,22.128-3.137c1.682-1.31,3.518-3.537,4.049-3.567     c-0.799,1.202,0.137,0.578-0.477,1.639c1.672-2.701-0.729-1.1,1.73-4.664l0.908,1.25c-0.34-2.244,2.785-4.966,2.467-8.512     c0.717-1.084,0.799,1.168,0.039,3.662c1.055-2.767,0.279-3.212,0.549-5.496c0.291,0.768,0.678,1.583,0.875,2.394     c-0.688-2.675,0.703-4.503,1.049-6.058c-0.342-0.15-1.061,1.182-1.227-1.976c0.025-1.372,0.383-0.719,0.52-1.057     c-0.268-0.155-0.975-1.207-1.404-3.224c0.309-0.475,0.832,1.229,1.256,1.298c-0.273-1.603-0.742-2.826-0.762-4.057     c-1.24-2.59-0.439,0.346-1.443-1.112c-1.32-4.114,1.094-0.955,1.258-2.823c1.998,2.895,3.137,7.385,3.662,9.244     c-0.4-2.267-1.045-4.464-1.834-6.589c0.609,0.257-0.979-4.663,0.791-1.405c-1.889-6.945-8.078-13.435-13.773-16.479     c0.695,0.637,1.574,1.437,1.26,1.563c-2.834-1.685-2.336-1.818-2.742-2.53c-2.305-0.939-2.459,0.077-3.984,0.002     c-4.35-2.308-5.188-2.063-9.191-3.507l0.182,0.852c-2.881-0.96-3.357,0.362-6.47,0.002c-0.189-0.147,0.998-0.536,1.976-0.677     c-2.786,0.368-2.656-0.55-5.382,0.101c0.671-0.471,1.383-0.784,2.099-1.184c-2.271,0.138-5.424,1.322-4.451,0.244     c-3.705,1.654-10.286,3.975-13.979,7.438l-0.116-0.776c-1.692,2.031-7.379,6.066-7.832,8.699l-0.453,0.105     c-0.879,1.491-1.45,3.18-2.148,4.713c-1.151,1.963-1.688,0.756-1.524,1.064c-2.265,4.592-3.392,8.45-4.363,11.616     c0.692,1.035,0.017,6.232,0.278,10.391c-1.136,20.544,14.418,40.489,31.42,45.093c2.492,0.893,6.197,0.861,9.349,0.949     c-3.718-1.064-4.198-0.563-7.822-1.826c-2.613-1.232-3.185-2.637-5.037-4.244l0.733,1.295c-3.63-1.285-2.111-1.59-5.065-2.525     l0.783-1.021c-1.177-0.09-3.117-1.982-3.647-3.033l-1.288,0.051c-1.546-1.906-2.371-3.283-2.31-4.35l-0.416,0.742     c-0.471-0.809-5.691-7.158-2.983-5.68c-0.503-0.458-1.172-0.747-1.897-2.066l0.551-0.629c-1.301-1.677-2.398-3.826-2.314-4.542     c0.695,0.938,1.177,1.114,1.655,1.275c-3.291-8.164-3.476-0.449-5.967-8.31l0.526-0.042c-0.403-0.611-0.65-1.27-0.974-1.919     l0.23-2.285c-2.368-2.736-0.662-11.645-0.319-16.53c0.235-1.986,1.977-4.101,3.3-7.418l-0.806-0.138     c1.542-2.688,8.802-10.799,12.166-10.383c1.629-2.046-0.324-0.008-0.643-0.522c3.579-3.703,4.704-2.616,7.119-3.283     c2.603-1.545-2.235,0.604-1.001-0.589c4.503-1.149,3.19-2.614,9.063-3.197c0.62,0.352-1.437,0.544-1.953,1.001     c3.75-1.836,11.869-1.417,17.145,1.018c6.117,2.861,12.994,11.314,13.266,19.267l0.309,0.083     c-0.156,3.162,0.484,6.819-0.627,10.177L81.762,38.962"
    />
    <path
      i:knockout="Off"
      fill="#A80030"
      d="M44.658,49.695l-0.211,1.047c0.983,1.335,1.763,2.781,3.016,3.821     C46.561,52.804,45.892,52.077,44.658,49.695"
    />
    <path
      i:knockout="Off"
      fill="#A80030"
      d="M46.979,49.605c-0.52-0.576-0.826-1.268-1.172-1.956     c0.33,1.211,1.006,2.252,1.633,3.312L46.979,49.605"
    />
    <path
      i:knockout="Off"
      fill="#A80030"
      d="M88.063,40.675l-0.219,0.552c-0.402,2.858-1.273,5.686-2.605,8.309     C86.711,46.769,87.66,43.742,88.063,40.675"
    />
    <path
      i:knockout="Off"
      fill="#A80030"
      d="M55.598,0.446C56.607,0.077,58.08,0.243,59.154,0c-1.398,0.117-2.789,0.187-4.162,0.362     L55.598,0.446"
    />
    <path
      i:knockout="Off"
      fill="#A80030"
      d="M20.127,19.308c0.233,2.154-1.62,2.991,0.41,1.569     C21.627,18.423,20.113,20.2,20.127,19.308"
    />
    <path
      i:knockout="Off"
      fill="#A80030"
      d="M17.739,29.282c0.469-1.437,0.553-2.299,0.732-3.132     C17.178,27.804,17.875,28.157,17.739,29.282"
    />
  </svg>
</template>

<style lang="scss" scoped>
svg {
  display: block;
  path {
    fill: #a80030;
    stroke: none;
  }
  height: auto;
}
</style>
